export default "__VITE_ASSET__c7827c19__"